// material-ui
import { styled, Theme } from '@mui/material/styles';
import { Box } from '@mui/material';

// project import
import { DRAWER_TRANSITION_DURATION, DRAWER_TRANSITION_EASING } from '../MiniDrawerStyled';

// ==============================|| DRAWER HEADER - STYLED ||============================== //

interface Props {
  theme: Theme;
  open: boolean;
}

const DrawerHeaderStyled = styled(Box, { shouldForwardProp: (prop) => prop !== 'open' })(({ theme, open }: Props) => ({
  ...theme.mixins.toolbar,
  display: 'flex',
  alignItems: 'center',
  justifyContent: open ? 'flex-start' : 'center',
  marginLeft: open ? '30px' : 0,
  marginRight: open ? '30px' : 0,
  paddingTop: open ? '30px' : 0,
  paddingBottom: open ? '30px' : 0,
  // Margins/paddings swap with `open`; without a transition they snapped a
  // frame before the drawer width caught up, jolting the logo sideways.
  transition: theme.transitions.create(['margin', 'padding'], {
    easing: DRAWER_TRANSITION_EASING,
    duration: DRAWER_TRANSITION_DURATION
  }),
  borderBottom: `1px solid ${theme.palette.divider}`,
  flexShrink: 0
}));

export default DrawerHeaderStyled;
